'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.postcode.service
 * @description
 * # postcode.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('postcodeService', function(BaseService, errorService, appSettings) {

    var service = new BaseService();
    service.autocomplete = autocomplete;
    service.geocode = geocode;
    service.getAddresses = getAddresses;

    return service;

    function autocomplete(postcode) {
      var trimmedPostcode = postcode.replace(' ', '');
      var config = {
        ignore: true
      };

      return service.http.get(appSettings.postcodes.baseUrl + '/postcodes/' + trimmedPostcode + '/autocomplete', config)
        .then(handleSuccess)
        .catch(handleError);
    }

    function geocode(address) {
      var config = {
        ignore: true
      };

      return service.http.get(appSettings.google.geocode.baseUrl + '?address=' + address, config)
        .then(handleSuccess)
        .catch(handleError);
    }

    function getAddresses(postcode) {
      postcode = postcode.replace(/\s/g, '');
      return service.http.get(service.baseUrl + '/lookups/postcodes/' + postcode)
        .then(handleSuccess)
        .catch(handleError);
    }

    function handleSuccess(response) {
      return !!response.data.result ?
          response.data.result : !!response.data.results ?
          response.data.results : response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }
  });
